namespace Newtonsoft.ViewModels.Account {
    export class ForgotPasswordViewModel {
        emailAddress = ko.observable<string>().extend({
            required: {
                params: true,
                message: "Your email address is required"
            }
        });
        complete = ko.observable<boolean>();
        message = ko.observable<string>();
        validation: any;
        tokenHeader = ko.observable<string>();

        constructor(tokenHeader) {
            this.tokenHeader(tokenHeader);
            this.validation = ko.validatedObservable(this);
        }

        async forgotPassword() {
            if (!this.validation.isValid()) {
                this.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                emailAddress: this.emailAddress()
            });

            Newtonsoft.showLoading("body");

            try {
                const response = await fetch("/api/account/forgotpassword", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    this.message("Email sent. Please check your inbox to reset your password.");
                    this.complete(true);
                } else {
                    await Newtonsoft.handleFailure(this, response);
                }
            } finally {
                Newtonsoft.hideLoading("body");
            }
        }
    }
}
